import moment from 'moment'

export const isEmail = (email) => {
  if(!email) {
    return false
  }
  const regex = /^([a-zA-Z0-9_.+-Çç])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/

  return regex.test(email)
}

export const getDayName = (timestamp) => {
  const day = moment(timestamp?.toJSDate()).calendar(null, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd D MMM',
    lastDay: '[Yesterday] D MMM',
    lastWeek: 'dddd D MMM',
    sameElse: 'dddd D MMM'
  })
  return day
}

export const getTranslatedDayName = (timestamp, t) => {
  const day = moment(timestamp?.toJSDate()).calendar(null, {
    sameDay: `[${t('getDayNameFunction.today')}]`,
    nextDay: `[${t('getDayNameFunction.tomorrow')}]`,
    nextWeek: 'dddd D MMM',
    lastDay: `[${t('getDayNameFunction.yesterday')}] D MMM`,
    lastWeek: 'dddd D MMM',
    sameElse: 'dddd D MMM'
  })
  return day
}
export const getDayNameWithTime = (timestamp) => {
  const day = moment(timestamp?.toJSDate()).calendar(null, {
    sameDay: '[Today] HH:mm',
    nextDay: '[Tomorrow] HH:mm',
    nextWeek: 'D MMM HH:mm',
    lastDay: '[Yesterday] D MMM HH:mm',
    lastWeek: 'D MMM HH:mm',
    sameElse: 'D MMM HH:mm'
  })
  return day
}

export const checkThatIsNumber = (str) => {
  return (str && /^\d+$/.test(str?.trim())) ? true : false
}